const WINDOWS_RESERVED = /^(?:con|prn|aux|nul|com[1-9]|lpt[1-9])(?:\.|$)/i;
// Control characters are intentionally removed from generated download names.
// eslint-disable-next-line no-control-regex
const UNSAFE = new RegExp('[\\x00-\\x1f\\x7f<>:"/\\\\|?*%]+', 'gu');

export function outputFilename(sourceName: string): string {
  const normalized = sourceName.normalize('NFKC');
  const dot = normalized.lastIndexOf('.');
  const withoutExtension = dot > 0 ? normalized.slice(0, dot) : normalized;
  let stem = withoutExtension
    .replace(UNSAFE, '-')
    .replace(/\s+/g, ' ')
    .replace(/-+/g, '-')
    .trim()
    .replace(/^[. -]+|[. -]+$/g, '');

  stem = [...stem]
    .slice(0, 80)
    .join('')
    .replace(/[. ]+$/g, '');
  if (!stem || WINDOWS_RESERVED.test(stem)) stem = 'image';
  return `${stem}.webp`;
}
